import { createGlobalStyle } from "styled-components";

const ToastifyStyle = createGlobalStyle`
  .Toastify {
    &__close-button {
      && {
        display: none;
      }
    }

    &__toast {
      && {
        border-radius: 12px;
        min-height: 42px;
        padding: 0;
      }
    }

    &__toast-container {
      && {
        width: 300px;
        padding: 0;
      }
    }

    &__toast-body {
      && {
        padding: 0;
      }
    }
  }
`;

export default ToastifyStyle;
